export default __webpack_public_path__ + "static/media/588.0ab3ad72.png";